import type { FC } from "react";

import { displayOutcomeName } from "components/outcomes/helpers";
import { OutcomeAssessmentType } from "components/server-types";
import { OutcomeChip } from "mds/components/OutcomeChip";
import { NestedPageOutcomeType } from "store/selectors";

/** Displays a single outcome and possibly its score in a list of outcomes. */
interface OutcomeScoreProps {
  pageOutcome: NestedPageOutcomeType;
  className?: string;
  onClick?: () => void;
  to?: string;
  outcomeAssessment?: Pick<OutcomeAssessmentType, "score">;
}

export const PageOutcomeScore: FC<OutcomeScoreProps> = ({
  pageOutcome,
  className = "",
  onClick,
  to,
  outcomeAssessment,
}) => {
  const title = displayOutcomeName(pageOutcome.outcome);

  return (
    <OutcomeChip
      className={className}
      eventName="Page outcome - View"
      eventProps={{ outcome: pageOutcome.outcome.title }}
      score={outcomeAssessment?.score}
      title={title}
      to={to}
      onClick={onClick}
    />
  );
};
